import { render } from "./Widget2.vue?vue&type=template&id=65ec6798&scoped=true"
import script from "./Widget2.vue?vue&type=script&lang=js"
export * from "./Widget2.vue?vue&type=script&lang=js"

import "./Widget2.vue?vue&type=style&index=0&id=65ec6798&lang=scss"
import "./Widget2.vue?vue&type=style&index=1&id=65ec6798&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65ec6798"]])

export default __exports__